import { useQueryClient } from '@tanstack/react-query';
import {
    useAddNewConversationToReportField,
    useAddNewReplyToConversation,
    useDeleteConversation,
    useDeleteReply,
    useGetConversationsForReportField,
    useReopenConversation,
    useResolveConversation,
    useUpdateConversation,
    useUpdateReply,
} from '../api/collaboration/collaboration';

export const useCommentDataItemsForReportField = (reportId?: string, reportColumnName?: string, reportRowNumber?: string) => {
    const queryClient = useQueryClient();

    const {
        data: itemsField,
        isError: isErrorField,
        isLoading: isLoadingField,
        isFetching: isFetchingField,
        queryKey: commentQueryKeyField,
        refetch: refetchField,
        //orval created these as string types so we cannot pass undefined
    } = useGetConversationsForReportField(reportId ?? '0', reportColumnName ?? '', reportRowNumber ?? '0');

    const mutationHandler = {
        mutation: {
            onSuccess: () => {
                queryClient.invalidateQueries(commentQueryKeyField);
            },
        },
    };

    const { mutateAsync: mutateAsyncField } = useAddNewConversationToReportField(mutationHandler);

    const { mutateAsync: updateConversationAsync } = useUpdateConversation(mutationHandler);

    const { mutateAsync: deleteConversationAsync } = useDeleteConversation(mutationHandler);

    const { mutateAsync: addReplyAsync } = useAddNewReplyToConversation(mutationHandler);

    const { mutateAsync: updateReplyAsync } = useUpdateReply(mutationHandler);

    const { mutateAsync: deleteReplyAsync } = useDeleteReply(mutationHandler);

    const { mutateAsync: resolveConversationAsync } = useResolveConversation(mutationHandler);

    const { mutateAsync: reopenConversationAsync } = useReopenConversation(mutationHandler);

    return {
        isLoadingItems: isLoadingField,
        isFetchingItems: isFetchingField,
        isErrorItems: isErrorField,
        items: itemsField?.conversations ?? [],
        mutateAsync: mutateAsyncField,
        updateConversationAsync,
        deleteConversationAsync,
        resolveConversationAsync,
        reopenConversationAsync,
        addReplyAsync,
        updateReplyAsync,
        deleteReplyAsync,
        refetchItems: refetchField,
        queryKey: commentQueryKeyField,
    };
};
